import React, { Component, useState } from "react";
// import "./PerfEvalCEOFormEdit.css";
// import { Form,Button } from "react-bootstrap";
import { Form, Button, Col, Row } from "react-bootstrap";
import { MonthYearData } from "../../../shared/util/vars";
// import axios from "axios";

export default function PerfEvalCEOForm(props) {

  const [FromDateData, setFromDateData] = useState("");

  const {
    onFormClose,
    handlePerfEvalSubmit,
    HandleEdit,
    Monthyear,
    Communication,
    Collaboration,
    Problemsolving,
    Quality,
    Attendance,
    Meetdeadline,
  } = props;

  return (
    <div>
      <h2 id="role-form-title">Add New Performance Evaluation</h2>

      <div id="role-form-outer-div">
        <Form id="form" onSubmit={(e) => handlePerfEvalSubmit(e)}>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Select Month & Year
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                as="select"
                required
                onChange={(e) => HandleEdit("Monthyear", e.target.value)}>
                <option value="" disabled selected>
                  Please select month and year
                </option>
                {MonthYearData.map((options, id) => (
                  <option key={id} value={options.value}>
                    {options.option}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Communication Skills
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Communication", Number(Communication) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                value={Communication}
                onChange={(e) => HandleEdit("Communication", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Communication", Number(Communication) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Collaboration and Teamwork
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Collaboration", Number(Collaboration) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                value={Collaboration}
                onChange={(e) => HandleEdit("Collaboration", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Collaboration", Number(Collaboration) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Problem Solving
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Problemsolving", Number(Problemsolving) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                value={Problemsolving}
                onChange={(e) => HandleEdit("Problemsolving", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Problemsolving", Number(Problemsolving) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Quality and Accuracy of work
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() => HandleEdit("Quality", Number(Quality) - 1)}>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                value={Quality}
                onChange={(e) => HandleEdit("Quality", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() => HandleEdit("Quality", Number(Quality) + 1)}>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Attendance, punctuality and reliability
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Attendance", Number(Attendance) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                value={Attendance}
                onChange={(e) => HandleEdit("Attendance", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Attendance", Number(Attendance) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Accomplish Goals and Meet deadlines
            </Form.Label>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Meetdeadline", Number(Meetdeadline) - 1)
                }>
                -
              </Button>
            </Col>
            <Col sm={2} className="form-input">
              <Form.Control
                type="Number"
                required
                value={Meetdeadline}
                onChange={(e) => HandleEdit("Meetdeadline", e.target.value)}
              />
            </Col>
            <Col sm={1} className="form-input">
              <Button
                onClick={() =>
                  HandleEdit("Meetdeadline", Number(Meetdeadline) + 1)
                }>
                +
              </Button>
            </Col>
          </Form.Group>

          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button type="submit">Add</Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={onFormClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}
